import {
  NormalizedStorageObject,
  StorageObject,
} from "../../../../../services/api/instances/storageApi/types/object_types";
import type { StorageObjectValue } from "../../../../../services/api/instances/storageApi/types/service_types";

export function normalizeStorageObjects<T extends StorageObjectValue>(
  objects: StorageObject<T>[],
  parentId: string | null = null,
  entities: Record<string, NormalizedStorageObject<T>> = {},
  ids: string[] = [],
): { entities: Record<string, NormalizedStorageObject<T>>; ids: string[] } {
  for (const obj of objects) {
    const { children, ...rest } = obj;
    entities[obj.id] = {
      ...rest,
      parentId,
      childrenIds: (children?.map((c) => c.id) || []) as string[],
    };

    if (!ids.includes(obj.id)) {
      ids.push(obj.id);
    }

    if (children && obj.value === null) {
      normalizeStorageObjects(children, obj.id, entities, ids);
    }
  }

  return { entities, ids };
}
